// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormHeader-module__font-s-10___fjEZP {
  font-size: 10px !important;
}

.FormHeader-module__font-s-12___c3IUP {
  font-size: 12px !important;
}

.FormHeader-module__font-s-13___kb6_C {
  font-size: 13px !important;
}

.FormHeader-module__font-s-14___rYJfd {
  font-size: 14px !important;
}

.FormHeader-module__font-s-15___sn06M {
  font-size: 15px !important;
}

.FormHeader-module__font-s-16___T04dn {
  font-size: 16px !important;
}

.FormHeader-module__font-s-18___VBWax {
  font-size: 18px !important;
}

.FormHeader-module__font-s-20___RZq4V {
  font-size: 20px !important;
}

.FormHeader-module__font-s-22___izppF {
  font-size: 22px !important;
}

.FormHeader-module__font-s-28___e3COC {
  font-size: 28px !important;
}

.FormHeader-module__font-w-400___a5RCs {
  font-weight: 400 !important;
}

.FormHeader-module__font-w-500___UMifL {
  font-weight: 500 !important;
}

.FormHeader-module__font-w-600___jZC1E {
  font-weight: 600 !important;
}

.FormHeader-module__font-w-700___rmSVp {
  font-weight: 700 !important;
}

.FormHeader-module__p-5___Ku9kw {
  padding: 5px !important;
}

.FormHeader-module__p-12___oKn0V {
  padding: 12px !important;
}

.FormHeader-module__p-16___oCDaC {
  padding: 16px !important;
}

.FormHeader-module__p-30___helfs {
  padding: 30px !important;
}

.FormHeader-module__p-b-0___yYOup {
  padding-bottom: 0 !important;
}

.FormHeader-module__p-b-5___OD9gc {
  padding-bottom: 5px !important;
}

.FormHeader-module__p-b-10___qoFUC {
  padding-bottom: 10px !important;
}

.FormHeader-module__p-b-12___FSmGI {
  padding-bottom: 12px !important;
}

.FormHeader-module__p-b-16___br5rp {
  padding-bottom: 16px !important;
}

.FormHeader-module__p-b-18___tXx7C {
  padding-bottom: 18px !important;
}

.FormHeader-module__p-b-20___RDDXg {
  padding-bottom: 20px !important;
}

.FormHeader-module__p-b-25___lyCBA {
  padding-bottom: 25px !important;
}

.FormHeader-module__p-b-30___ovyy_ {
  padding-bottom: 30px !important;
}

.FormHeader-module__p-b-50___hm4Gc {
  padding-bottom: 50px !important;
}

.FormHeader-module__p-t-0___PJAJn {
  padding-top: 0 !important;
}

.FormHeader-module__p-t-12___THDBX {
  padding-top: 12px !important;
}

.FormHeader-module__p-t-16___sVX_Z {
  padding-top: 16px !important;
}

.FormHeader-module__p-t-18___Llsjo {
  padding-top: 18px !important;
}

.FormHeader-module__p-t-20___tLgNc {
  padding-top: 20px !important;
}

.FormHeader-module__p-t-30___G4C_Q {
  padding-top: 30px !important;
}

.FormHeader-module__p-t-40___Faho0 {
  padding-top: 40px !important;
}

.FormHeader-module__p-t-50___MCuDE {
  padding-top: 50px !important;
}

.FormHeader-module__p-l-20___Qcg3U {
  padding-left: 20px !important;
}

.FormHeader-module__p-l-30___msFzt {
  padding-left: 30px !important;
}

.FormHeader-module__p-l-40___AZB0j {
  padding-left: 40px !important;
}

.FormHeader-module__p-r-16___Mb21C {
  padding-right: 16px !important;
}

.FormHeader-module__p-r-20___Ah1EJ {
  padding-right: 20px !important;
}

.FormHeader-module__p-r-30___EVKV6 {
  padding-right: 30px !important;
}

.FormHeader-module__p-r-50___jnCKv {
  padding-right: 50px !important;
}

.FormHeader-module__p-r-60___QWg_f {
  padding-right: 60px !important;
}

.FormHeader-module__m-b-1___Kd0NT {
  margin-bottom: 1px !important;
}

.FormHeader-module__m-b-2___FA1bl {
  margin-bottom: 2px !important;
}

.FormHeader-module__m-b-6___HX5Mh {
  margin-bottom: 6px !important;
}

.FormHeader-module__m-b-8___pZUua {
  margin-bottom: 8px !important;
}

.FormHeader-module__m-b-10___u9dwT {
  margin-bottom: 10px !important;
}

.FormHeader-module__m-b-14___NkmS6 {
  margin-bottom: 14px !important;
}

.FormHeader-module__m-b-16___ErwqC {
  margin-bottom: 16px !important;
}

.FormHeader-module__m-b-20___VarUC {
  margin-bottom: 20px !important;
}

.FormHeader-module__m-b-22___RYSYL {
  margin-bottom: 22px !important;
}

.FormHeader-module__m-b-24___n8n4G {
  margin-bottom: 24px !important;
}

.FormHeader-module__m-b-30___tMBhX {
  margin-bottom: 30px !important;
}

.FormHeader-module__m-b-32___v6nab {
  margin-bottom: 32px !important;
}

.FormHeader-module__m-b-40___dB99g {
  margin-bottom: 40px !important;
}

.FormHeader-module__m-t-2___XPU7D {
  margin-top: 2px !important;
}

.FormHeader-module__m-t-3___qy5dK {
  margin-top: 3px !important;
}

.FormHeader-module__m-t-4___wtoxB {
  margin-top: 4px !important;
}

.FormHeader-module__m-t-5___zqjU2 {
  margin-top: 5px !important;
}

.FormHeader-module__m-t-8___HfLkF {
  margin-top: 8px !important;
}

.FormHeader-module__m-t-10___AwQf5 {
  margin-top: 10px !important;
}

.FormHeader-module__m-t-15___Vl3_g {
  margin-top: 15px !important;
}

.FormHeader-module__m-t-16___z2Rl9 {
  margin-top: 16px !important;
}

.FormHeader-module__m-t-20___D_ldW {
  margin-top: 20px !important;
}

.FormHeader-module__m-t-22___WvgYs {
  margin-top: 22px !important;
}

.FormHeader-module__m-t-30___GgOla {
  margin-top: 30px !important;
}

.FormHeader-module__m-t-32___kUBVB {
  margin-top: 32px !important;
}

.FormHeader-module__m-l-auto___sVwnH {
  margin-left: auto !important;
}

.FormHeader-module__m-l-4___LHkTs {
  margin-left: 4px !important;
}

.FormHeader-module__m-l-5___H7C4U {
  margin-left: 5px !important;
}

.FormHeader-module__m-l-6___xWYlU {
  margin-left: 6px !important;
}

.FormHeader-module__m-l-8___HVUyc {
  margin-left: 8px !important;
}

.FormHeader-module__m-l-10___KmP3h {
  margin-left: 10px !important;
}

.FormHeader-module__m-l-16___XN_xq {
  margin-left: 16px !important;
}

.FormHeader-module__m-l-20___BFNOH {
  margin-left: 20px !important;
}

.FormHeader-module__m-l-24___PNmuo {
  margin-left: 24px !important;
}

.FormHeader-module__m-l-30___VACyD {
  margin-left: 30px !important;
}

.FormHeader-module__m-l-35____ohiy {
  margin-left: 35px !important;
}

.FormHeader-module__m-l-40___sHb4c {
  margin-left: 40px !important;
}

.FormHeader-module__m-r-8___bx1An {
  margin-right: 8px !important;
}

.FormHeader-module__m-r-10___BnFMr {
  margin-right: 10px !important;
}

.FormHeader-module__m-r-16___VLOoO {
  margin-right: 16px !important;
}

.FormHeader-module__m-r-20___NYajc {
  margin-right: 20px !important;
}

.FormHeader-module__m-r-24___S8mEe {
  margin-right: 24px !important;
}

.FormHeader-module__m-r-30___auIq_ {
  margin-right: 30px !important;
}

.FormHeader-module__m-r-40___uYqD6 {
  margin-right: 40px !important;
}

.FormHeader-module__border-r-3___XeIqk {
  border-radius: 3px !important;
}

.FormHeader-module__border-r-4___GU894 {
  border-radius: 4px !important;
}

.FormHeader-module__border-r-6___D8v_J {
  border-radius: 6px !important;
}

.FormHeader-module__border-r-10___PjCpF {
  border-radius: 10px !important;
}

.FormHeader-module__border-r-12___dincp {
  border-radius: 12px !important;
}

.FormHeader-module__border-r-16___HGy3H {
  border-radius: 16px !important;
}

.FormHeader-module__border-r-50___fF5GZ {
  border-radius: 50% !important;
}

.FormHeader-module__primary-border___Q0P_v {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.FormHeader-module__primary-border-b___i0WiP {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.FormHeader-module__primary-border-t___foJlm {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.FormHeader-module__primary-border-l___XKksm {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.FormHeader-module__primary-border-r___RWefD {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.FormHeader-module__secondary-border___M2CTf {
  border: 1px solid #637768;
}

.FormHeader-module__secondary-border-b___XlpnC {
  border-bottom: 1px solid #637768;
}

.FormHeader-module__secondary-border-t___RjWuR {
  border-top: 1px solid #637768;
}

.FormHeader-module__secondary-border-l___rnKJm {
  border-left: 1px solid #637768;
}

.FormHeader-module__secondary-border-r___m3VOB {
  border-right: 1px solid #637768;
}

.FormHeader-module__gap-0___BWqgF {
  gap: 0 !important;
}

.FormHeader-module__gap-2___eCuzE {
  gap: 2px !important;
}

.FormHeader-module__gap-4___QGdAd {
  gap: 4px !important;
}

.FormHeader-module__gap-5___Umcsq {
  gap: 5px !important;
}

.FormHeader-module__gap-6___iiOis {
  gap: 6px !important;
}

.FormHeader-module__gap-8___YDpQX {
  gap: 8px !important;
}

.FormHeader-module__gap-10___D3LRO {
  gap: 10px !important;
}

.FormHeader-module__gap-12___o8zAs {
  gap: 12px !important;
}

.FormHeader-module__gap-14___EOLAW {
  gap: 14px !important;
}

.FormHeader-module__gap-16___XWtEQ {
  gap: 16px !important;
}

.FormHeader-module__gap-18___YPnkz {
  gap: 18px !important;
}

.FormHeader-module__gap-20___AoSoZ {
  gap: 20px !important;
}

.FormHeader-module__gap-24___TQK5X {
  gap: 24px !important;
}

.FormHeader-module__gap-26___Q6xTl {
  gap: 26px !important;
}

.FormHeader-module__gap-30___m3bYC {
  gap: 30px !important;
}

.FormHeader-module__gap-32___pVNQa {
  gap: 32px !important;
}

.FormHeader-module__gap-40___oyCC9 {
  gap: 40px !important;
}

.FormHeader-module__gap-50___dEsoo {
  gap: 50px !important;
}

.FormHeader-module__flex-1___WGyG7 {
  flex: 1;
}

.FormHeader-module__flex-none___CgUZw {
  flex: none !important;
}

.FormHeader-module__flex-column___W3xoX {
  display: flex;
  flex-direction: column !important;
}

.FormHeader-module__flex-row___fCXUm {
  display: flex;
  flex-direction: row !important;
}

.FormHeader-module__vertically-centered___QHt2Z {
  display: flex;
  align-items: center !important;
}

.FormHeader-module__horizontally-centered___TO2ad {
  display: flex;
  justify-content: center !important;
}

.FormHeader-module__horizontally-end___VICzL {
  display: flex;
  justify-content: end !important;
}

.FormHeader-module__vertically-start___s6Trq {
  display: flex;
  align-items: start !important;
}

.FormHeader-module__space-between___wfX9e {
  display: flex;
  justify-content: space-between !important;
}

.FormHeader-module__flex-wrap___d6DMS {
  flex-wrap: wrap !important;
}

.FormHeader-module__height-100___GPmWy {
  height: 100%;
}

.FormHeader-module__width-50___VKvtE {
  width: 50% !important;
}

.FormHeader-module__width-100___hBJmL {
  width: 100%;
}

.FormHeader-module__cursor-pointer___yZfKZ {
  cursor: pointer;
}

.FormHeader-module__cursor-not-allowed___gj8Pv {
  cursor: not-allowed !important;
}

.FormHeader-module__absolute-centered___BiAdl {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.FormHeader-module__absolute___Hp_3w {
  position: absolute;
}

.FormHeader-module__relative___ATXqy {
  position: relative;
}

.FormHeader-module__fixed___lLfJn {
  position: fixed;
}

.FormHeader-module__visible___rRUBX {
  opacity: 1;
}

.FormHeader-module__invisible___ZGQEv {
  opacity: 0;
}

.FormHeader-module__col-90___uNTUn {
  width: 90% !important;
}

.FormHeader-module__col-auto___YpUn7 {
  width: auto !important;
}

.FormHeader-module__medical-tabs___kezla {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.FormHeader-module__medical-table-new___JkNGP {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FormHeader-module__medical-table-new___JkNGP:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FormHeader-module__medical-table-new___JkNGP::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FormHeader-module__medical-table-new___JkNGP::-webkit-scrollbar-track {
  display: none;
}
.FormHeader-module__medical-table-new___JkNGP.FormHeader-module__no-pagination___r5lJ0 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FormHeader-module__medical-table-new___JkNGP.FormHeader-module__no-pagination___r5lJ0:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FormHeader-module__medical-table-new___JkNGP.FormHeader-module__no-pagination___r5lJ0::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FormHeader-module__medical-table-new___JkNGP.FormHeader-module__no-pagination___r5lJ0::-webkit-scrollbar-track {
  display: none;
}

.FormHeader-module__medical-table-empty___Py8U7 {
  padding: 14px 40px !important;
}

.FormHeader-module__icon-btn___z4b4i {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.FormHeader-module__search-icon___f4kD8 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.FormHeader-module__disable-select___BHNQE {
  user-select: none;
}

.FormHeader-module__break-word___smixz {
  word-break: break-word;
}

.FormHeader-module__popup-clear-btn___WsG5k {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.FormHeader-module__scroll-m-b-20___kq1KA {
  scroll-margin-bottom: 20px;
}

.FormHeader-module__header___Zwglr {
  background-color: #fdfbf8;
  border: 1px solid rgba(91, 91, 91, 0.1);
  flex-direction: row;
  padding: 18px 30px;
  display: flex;
}
.FormHeader-module__header___Zwglr .FormHeader-module__title___It58U {
  color: #375844;
}
.FormHeader-module__header___Zwglr .FormHeader-module__checkbox___J_IVV {
  width: 280px;
}
.FormHeader-module__header___Zwglr .FormHeader-module__toggleButton___MzlrM {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
}
.FormHeader-module__header___Zwglr .FormHeader-module__toggleButton___MzlrM.FormHeader-module__collapsed___WKU2z {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/FormHeader/FormHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA3pBE;EACE,YAAA;AA6pBJ;AA1pBE;EACE,eAAA;EACA,sCAAA;AA4pBJ;AA1pBI;EACE,yBAAA;AA4pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.header {\n  background-color: get-color(grayNew, lighter);\n  border: 1px solid rgba(91, 91, 91, 0.1);\n  flex-direction: row;\n  padding: 18px 30px;\n  display: flex;\n\n  .title {\n    color: get-color(greenNew, dark);\n  }\n\n  .checkbox {\n    width: 280px;\n  }\n\n  .toggleButton {\n    cursor: pointer;\n    transition: transform 0.3s ease-in-out;\n\n    &.collapsed {\n      transform: rotate(180deg);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `FormHeader-module__font-s-10___fjEZP`,
	"fontS12": `FormHeader-module__font-s-12___c3IUP`,
	"fontS13": `FormHeader-module__font-s-13___kb6_C`,
	"fontS14": `FormHeader-module__font-s-14___rYJfd`,
	"fontS15": `FormHeader-module__font-s-15___sn06M`,
	"fontS16": `FormHeader-module__font-s-16___T04dn`,
	"fontS18": `FormHeader-module__font-s-18___VBWax`,
	"fontS20": `FormHeader-module__font-s-20___RZq4V`,
	"fontS22": `FormHeader-module__font-s-22___izppF`,
	"fontS28": `FormHeader-module__font-s-28___e3COC`,
	"fontW400": `FormHeader-module__font-w-400___a5RCs`,
	"fontW500": `FormHeader-module__font-w-500___UMifL`,
	"fontW600": `FormHeader-module__font-w-600___jZC1E`,
	"fontW700": `FormHeader-module__font-w-700___rmSVp`,
	"p5": `FormHeader-module__p-5___Ku9kw`,
	"p12": `FormHeader-module__p-12___oKn0V`,
	"p16": `FormHeader-module__p-16___oCDaC`,
	"p30": `FormHeader-module__p-30___helfs`,
	"pB0": `FormHeader-module__p-b-0___yYOup`,
	"pB5": `FormHeader-module__p-b-5___OD9gc`,
	"pB10": `FormHeader-module__p-b-10___qoFUC`,
	"pB12": `FormHeader-module__p-b-12___FSmGI`,
	"pB16": `FormHeader-module__p-b-16___br5rp`,
	"pB18": `FormHeader-module__p-b-18___tXx7C`,
	"pB20": `FormHeader-module__p-b-20___RDDXg`,
	"pB25": `FormHeader-module__p-b-25___lyCBA`,
	"pB30": `FormHeader-module__p-b-30___ovyy_`,
	"pB50": `FormHeader-module__p-b-50___hm4Gc`,
	"pT0": `FormHeader-module__p-t-0___PJAJn`,
	"pT12": `FormHeader-module__p-t-12___THDBX`,
	"pT16": `FormHeader-module__p-t-16___sVX_Z`,
	"pT18": `FormHeader-module__p-t-18___Llsjo`,
	"pT20": `FormHeader-module__p-t-20___tLgNc`,
	"pT30": `FormHeader-module__p-t-30___G4C_Q`,
	"pT40": `FormHeader-module__p-t-40___Faho0`,
	"pT50": `FormHeader-module__p-t-50___MCuDE`,
	"pL20": `FormHeader-module__p-l-20___Qcg3U`,
	"pL30": `FormHeader-module__p-l-30___msFzt`,
	"pL40": `FormHeader-module__p-l-40___AZB0j`,
	"pR16": `FormHeader-module__p-r-16___Mb21C`,
	"pR20": `FormHeader-module__p-r-20___Ah1EJ`,
	"pR30": `FormHeader-module__p-r-30___EVKV6`,
	"pR50": `FormHeader-module__p-r-50___jnCKv`,
	"pR60": `FormHeader-module__p-r-60___QWg_f`,
	"mB1": `FormHeader-module__m-b-1___Kd0NT`,
	"mB2": `FormHeader-module__m-b-2___FA1bl`,
	"mB6": `FormHeader-module__m-b-6___HX5Mh`,
	"mB8": `FormHeader-module__m-b-8___pZUua`,
	"mB10": `FormHeader-module__m-b-10___u9dwT`,
	"mB14": `FormHeader-module__m-b-14___NkmS6`,
	"mB16": `FormHeader-module__m-b-16___ErwqC`,
	"mB20": `FormHeader-module__m-b-20___VarUC`,
	"mB22": `FormHeader-module__m-b-22___RYSYL`,
	"mB24": `FormHeader-module__m-b-24___n8n4G`,
	"mB30": `FormHeader-module__m-b-30___tMBhX`,
	"mB32": `FormHeader-module__m-b-32___v6nab`,
	"mB40": `FormHeader-module__m-b-40___dB99g`,
	"mT2": `FormHeader-module__m-t-2___XPU7D`,
	"mT3": `FormHeader-module__m-t-3___qy5dK`,
	"mT4": `FormHeader-module__m-t-4___wtoxB`,
	"mT5": `FormHeader-module__m-t-5___zqjU2`,
	"mT8": `FormHeader-module__m-t-8___HfLkF`,
	"mT10": `FormHeader-module__m-t-10___AwQf5`,
	"mT15": `FormHeader-module__m-t-15___Vl3_g`,
	"mT16": `FormHeader-module__m-t-16___z2Rl9`,
	"mT20": `FormHeader-module__m-t-20___D_ldW`,
	"mT22": `FormHeader-module__m-t-22___WvgYs`,
	"mT30": `FormHeader-module__m-t-30___GgOla`,
	"mT32": `FormHeader-module__m-t-32___kUBVB`,
	"mLAuto": `FormHeader-module__m-l-auto___sVwnH`,
	"mL4": `FormHeader-module__m-l-4___LHkTs`,
	"mL5": `FormHeader-module__m-l-5___H7C4U`,
	"mL6": `FormHeader-module__m-l-6___xWYlU`,
	"mL8": `FormHeader-module__m-l-8___HVUyc`,
	"mL10": `FormHeader-module__m-l-10___KmP3h`,
	"mL16": `FormHeader-module__m-l-16___XN_xq`,
	"mL20": `FormHeader-module__m-l-20___BFNOH`,
	"mL24": `FormHeader-module__m-l-24___PNmuo`,
	"mL30": `FormHeader-module__m-l-30___VACyD`,
	"mL35": `FormHeader-module__m-l-35____ohiy`,
	"mL40": `FormHeader-module__m-l-40___sHb4c`,
	"mR8": `FormHeader-module__m-r-8___bx1An`,
	"mR10": `FormHeader-module__m-r-10___BnFMr`,
	"mR16": `FormHeader-module__m-r-16___VLOoO`,
	"mR20": `FormHeader-module__m-r-20___NYajc`,
	"mR24": `FormHeader-module__m-r-24___S8mEe`,
	"mR30": `FormHeader-module__m-r-30___auIq_`,
	"mR40": `FormHeader-module__m-r-40___uYqD6`,
	"borderR3": `FormHeader-module__border-r-3___XeIqk`,
	"borderR4": `FormHeader-module__border-r-4___GU894`,
	"borderR6": `FormHeader-module__border-r-6___D8v_J`,
	"borderR10": `FormHeader-module__border-r-10___PjCpF`,
	"borderR12": `FormHeader-module__border-r-12___dincp`,
	"borderR16": `FormHeader-module__border-r-16___HGy3H`,
	"borderR50": `FormHeader-module__border-r-50___fF5GZ`,
	"primaryBorder": `FormHeader-module__primary-border___Q0P_v`,
	"primaryBorderB": `FormHeader-module__primary-border-b___i0WiP`,
	"primaryBorderT": `FormHeader-module__primary-border-t___foJlm`,
	"primaryBorderL": `FormHeader-module__primary-border-l___XKksm`,
	"primaryBorderR": `FormHeader-module__primary-border-r___RWefD`,
	"secondaryBorder": `FormHeader-module__secondary-border___M2CTf`,
	"secondaryBorderB": `FormHeader-module__secondary-border-b___XlpnC`,
	"secondaryBorderT": `FormHeader-module__secondary-border-t___RjWuR`,
	"secondaryBorderL": `FormHeader-module__secondary-border-l___rnKJm`,
	"secondaryBorderR": `FormHeader-module__secondary-border-r___m3VOB`,
	"gap0": `FormHeader-module__gap-0___BWqgF`,
	"gap2": `FormHeader-module__gap-2___eCuzE`,
	"gap4": `FormHeader-module__gap-4___QGdAd`,
	"gap5": `FormHeader-module__gap-5___Umcsq`,
	"gap6": `FormHeader-module__gap-6___iiOis`,
	"gap8": `FormHeader-module__gap-8___YDpQX`,
	"gap10": `FormHeader-module__gap-10___D3LRO`,
	"gap12": `FormHeader-module__gap-12___o8zAs`,
	"gap14": `FormHeader-module__gap-14___EOLAW`,
	"gap16": `FormHeader-module__gap-16___XWtEQ`,
	"gap18": `FormHeader-module__gap-18___YPnkz`,
	"gap20": `FormHeader-module__gap-20___AoSoZ`,
	"gap24": `FormHeader-module__gap-24___TQK5X`,
	"gap26": `FormHeader-module__gap-26___Q6xTl`,
	"gap30": `FormHeader-module__gap-30___m3bYC`,
	"gap32": `FormHeader-module__gap-32___pVNQa`,
	"gap40": `FormHeader-module__gap-40___oyCC9`,
	"gap50": `FormHeader-module__gap-50___dEsoo`,
	"flex1": `FormHeader-module__flex-1___WGyG7`,
	"flexNone": `FormHeader-module__flex-none___CgUZw`,
	"flexColumn": `FormHeader-module__flex-column___W3xoX`,
	"flexRow": `FormHeader-module__flex-row___fCXUm`,
	"verticallyCentered": `FormHeader-module__vertically-centered___QHt2Z`,
	"horizontallyCentered": `FormHeader-module__horizontally-centered___TO2ad`,
	"horizontallyEnd": `FormHeader-module__horizontally-end___VICzL`,
	"verticallyStart": `FormHeader-module__vertically-start___s6Trq`,
	"spaceBetween": `FormHeader-module__space-between___wfX9e`,
	"flexWrap": `FormHeader-module__flex-wrap___d6DMS`,
	"height100": `FormHeader-module__height-100___GPmWy`,
	"width50": `FormHeader-module__width-50___VKvtE`,
	"width100": `FormHeader-module__width-100___hBJmL`,
	"cursorPointer": `FormHeader-module__cursor-pointer___yZfKZ`,
	"cursorNotAllowed": `FormHeader-module__cursor-not-allowed___gj8Pv`,
	"absoluteCentered": `FormHeader-module__absolute-centered___BiAdl`,
	"absolute": `FormHeader-module__absolute___Hp_3w`,
	"relative": `FormHeader-module__relative___ATXqy`,
	"fixed": `FormHeader-module__fixed___lLfJn`,
	"visible": `FormHeader-module__visible___rRUBX`,
	"invisible": `FormHeader-module__invisible___ZGQEv`,
	"col90": `FormHeader-module__col-90___uNTUn`,
	"colAuto": `FormHeader-module__col-auto___YpUn7`,
	"medicalTabs": `FormHeader-module__medical-tabs___kezla`,
	"medicalTableNew": `FormHeader-module__medical-table-new___JkNGP`,
	"noPagination": `FormHeader-module__no-pagination___r5lJ0`,
	"medicalTableEmpty": `FormHeader-module__medical-table-empty___Py8U7`,
	"iconBtn": `FormHeader-module__icon-btn___z4b4i`,
	"searchIcon": `FormHeader-module__search-icon___f4kD8`,
	"disableSelect": `FormHeader-module__disable-select___BHNQE`,
	"breakWord": `FormHeader-module__break-word___smixz`,
	"popupClearBtn": `FormHeader-module__popup-clear-btn___WsG5k`,
	"scrollMB20": `FormHeader-module__scroll-m-b-20___kq1KA`,
	"header": `FormHeader-module__header___Zwglr`,
	"title": `FormHeader-module__title___It58U`,
	"checkbox": `FormHeader-module__checkbox___J_IVV`,
	"toggleButton": `FormHeader-module__toggleButton___MzlrM`,
	"collapsed": `FormHeader-module__collapsed___WKU2z`
};
module.exports = ___CSS_LOADER_EXPORT___;
